import './separator.scss';

export const DiffSeparator = () => (
  <span data-testid="DiffSeparator" className="DiffSeparator">
    {' '}
    ●{' '}
  </span>
);
